export const entityConstants = {
  ADD_PROJECT_REQUEST: 'ADD_PROJECT_REQUEST',
  ADD_PROJECT_SUCCESS: 'ADD_PROJECT_SUCCESS',
  ADD_PROJECT_FAILURE: 'ADD_PROJECT_FAILURE',
  CLOSE_PROJECT_DIALOG: 'CLOSE_PROJECT_DIALOG',
  BULK_TASK_UPLOAD: 'BULK_TASK_UPLOAD',
  INVITE_REQUEST: 'INVITE_REQUEST',
  INVITE_SUCCESS: 'INVITE_SUCCESS',
  INVITE_FAILED: 'INVITE_FAILED',
  WEEK_FILTER: 'WEEK_FILTER',
  REQUEST_UPDATE: 'REQUEST_UPDATE',
  REQUEST_UPDATE_PENDING: 'REQUEST_UPDATE_PENDING',
  REQUEST_UPDATE_DONE: 'REQUEST_UPDATE_DONE',
  REQUEST_DIALOG_CLOSE: 'REQUEST_DIALOG_CLOSE'
}



// WEBPACK FOOTER //
// ./src/constants/entity.constants.js